import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { AuthContext, OfflineContext } from '@/contexts';
import { PERMISSION_TYPE, PRIVATE_PAGE_ROUTES } from '@/enums';
import { isSupportChatEnabled } from '@/helpers';

export const useCanUseSupportChat = () => {
  const { pathname } = useLocation();
  const { permissions } = useContext(AuthContext);
  const { isOnline } = useContext(OfflineContext);

  return (
    isSupportChatEnabled() &&
    isOnline &&
    permissions.includes(PERMISSION_TYPE.USE_SUPPORT_CHAT) &&
    !pathname.startsWith(PRIVATE_PAGE_ROUTES.MFA_SETUP)
  );
};
